import { Container } from 'react-bootstrap';
import { Link } from 'react-router';
import styles from './ErrorPage.module.css';

function NotFoundErrorPage() {
  return (
    <Container className={styles.ErrorPage}>
      <h1>Page not found</h1>
      <p className={"fw-bold"}>
        It looks like the page you're looking for doesn't exist or has been removed.
      </p>
      <p>
        Don't worry, its sometimes the best explorers who get lost.
      </p>
      <p>
        You can head over to the <Link to="/">home page</Link> and try searching for the page you wanted.
        If you expected something to be here please contact <a href="mailto:support@townsville.today">support@townsville.today</a> and report this fault.
      </p>
    </Container>
)
}

export default NotFoundErrorPage
